import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private config: {
    apiPrivateUrl?: string;
    enableConsoleLog?: boolean;
  } | null = null;

  load(): Promise<void> {
    return fetch('/assets/config.json')
      .then((res) => res.json())
      .then((data) => {
        this.config = data;
        this.applyConsolePolicy();
      })
      .catch(() => {
        this.config = null;
        this.applyConsolePolicy();
      });
  }

  get apiPrivateUrl(): string {
    return this.config?.apiPrivateUrl ?? '';
  }

  /** config.json มาก่อน ถ้าไม่มีใช้ environment.enableConsoleLog */
  get enableConsoleLog(): boolean {
    if (typeof this.config?.enableConsoleLog === 'boolean') {
      return this.config.enableConsoleLog;
    }
    return !!environment.enableConsoleLog;
  }

  private applyConsolePolicy(): void {
    if (this.enableConsoleLog) return;

    console.log = () => {};
    console.warn = () => {};
    console.error = () => {};
    console.info = () => {};
    console.debug = () => {};
  }
}
